import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';

import { ResponsiveTable } from '../../../common/components/data-display';
import { getContractType } from '../../../common/utils/helpers';
import { contractType } from '../../../common/enums';
import OpenFileLink from './OpenFileLink';
let baseWeb = process.env.REACT_APP_WEB_URL;

const Column = Table.Column;

const DocumentsList = ({ documents, token, t, accountRole, showCreatedAt }) => {

  const isInAdmin = window.location && window.location.href.indexOf('/admin') !== -1;

  return (
    <section className="documents-list">
      <ResponsiveTable dataSource={documents} rowKey={doc => doc.id}>
        {isInAdmin && (
          <Column
            title={t('Číslo')}
            dataIndex="contractNumber"
            key="contractNumber"
            render={(contractNumber, record) =>
              record.type === contractType.MANDATE ? record.id : contractNumber
            }
          />
        )}
        <Column
          title={t('Typ')}
          dataIndex="type"
          key="type"
          render={type => getContractType(type, accountRole)}
        />
        <Column
          title=""
          dataIndex="fileId"
          key="download"
          render={fileId => {
            if (fileId) {
              let href = ''
              let linkText = t('Prečítať');
              if (fileId.slice(-4) === '.pdf') {
                href = `${baseWeb}/documents/${fileId}`
              } else {
                href = `${process.env.REACT_APP_API_URL}/file/${fileId}?token=${token}`
              }

              return (
                <OpenFileLink href={href}>
                  {linkText}
              </OpenFileLink>
              )
            } else {
              return t('Čaká sa na vygenerovanie zmluvy')
            }
          }}
        />
        {showCreatedAt && (
          <Column
            title={t('Dátum nahrania')}
            dataIndex="updatedAt"
            key="updatedAt"
            render={(updatedAt) =>
              new Date(updatedAt).toLocaleString()
            }
          />
        )}
      </ResponsiveTable>
    </section>
  );
};

DocumentsList.propTypes = {
  documents: PropTypes.array.isRequired,
  token: PropTypes.string.isRequired,
  accountRole: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(DocumentsList);



// WEBPACK FOOTER //
// ./src/common/components/data-display/DocumentsList.js